export default __webpack_public_path__ + "static/media/Liftup.bad0056f.png";